/** @format */

const template = `
<div class="search-filter">
  <ng-form name="filterSelectorForm" novalidate ng-model-options="{ updateOn: 'default' }">
    <div class="input-group">
      <div class="row">
        <local-date-range-editor
          ng-model="ctrl.clonedParameterModel.value"
          ng-change="ctrl.onDateRangeChange()"
          hide-labels="false"
          end-date-disabled="false">
        </local-date-range-editor>
      </div>
    </div>
    <div class="row filter-preview-row">
      <div class="col-9">
        <div class="filter-preview-holder">
          <span class="filter-preview-title">{{ctrl.filterName}}</span>
          <span class="filter-preview-content">{{ctrl.clonedParameterModel.value | salesPeriod}}</span>
        </div>
      </div>
      <div class="col-3">
        <button
          type="submit"
          class="btn btn-lg btn-primary filter-submit"
          ng-click="ctrl.submitFilter()"
          ng-disabled="filterSelectorForm.$pristine || filterSelectorForm.$invalid"
          translate="SEARCH.FILTER_SELECTOR.OK">
        </button>
      </div>
    </div>
  </ng-form>
</div>
`;
export default template;
